export default __webpack_public_path__ + "static/media/risk-handling.bb41152f.svg";